"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectProductAmountSelector = void 0;
const getRecordSelector_1 = __importDefault(require("root/src/client/logic/api/selectors/getRecordSelector"));
const getProductAmount_1 = require("root/src/shared/util/getProductAmount");
const projectProductAmountSelector = (state, props) => {
    const project = (0, getRecordSelector_1.default)(state, props);
    if (!project) {
        return 0;
    }
    const { brandProduct, secondaryReward } = project;
    return (0, getProductAmount_1.getProductAmount)(brandProduct) + (0, getProductAmount_1.getProductAmount)(secondaryReward);
};
exports.projectProductAmountSelector = projectProductAmountSelector;
